import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { Survey as UiSurvey } from "@jti/ui/components/Survey";

import { useSurveyScriptUrl } from "./hooks/useSurveyScriptUrl";

import type { surveyInputs } from "./Survey.builder";

export type SurveyProps = BuilderComponentProps<typeof surveyInputs>;

export const Survey: FC<SurveyProps> = ({ identifier, domain }) => {
  const scriptUrl = useSurveyScriptUrl(identifier, domain);

  if (isEditing()) {
    return <div>Survey Placeholder</div>;
  }

  if (!scriptUrl) return null;
  return <UiSurvey scriptUrl={scriptUrl} />;
};
